export function DomainChip({ domain }: Readonly<{ domain: string }>): React.JSX.Element {
  return (
    <span className="inline-flex h-5.5 items-center rounded-sm border border-border bg-muted px-2 font-mono text-card-id tracking-tight text-foreground-default">
      @{domain}
    </span>
  );
}
